import { buildProductHistoryPresentation } from './product-history-presentation.js';
import { buildProductPairsPresentation } from './product-pairs-presentation.js';
import { insightPagePresentationSchema } from './insight-page-presentation.js';
/** The page's sections in the order shown. Loading placeholders list the same ids; every build is checked against it. */
export const insightsPageSectionIds = ['repeat-buying', 'product-pairs', 'paid-product-history', 'product-mix'];
/** Server declares every section's content and order; the browser performs no analytical selection. */
export function buildInsightsPage(answers) {
    const sections = [];
    sections.push({ kind: 'cards', id: 'repeat-buying', presentation: answers.repeatBuying.presentation });
    const pairs = answers.productPairs;
    sections.push({
        ...buildProductPairsPresentation({
            coverage: pairs.coverage,
            pairs: pairs.pairs.map(({ a, b, together, orders }) => ({ a, b, together, orders })),
        }),
        id: 'product-pairs',
    });
    const { coverage, recurrence, nextOrder } = answers.productHistory;
    sections.push(buildProductHistoryPresentation({ coverage, recurrence, nextOrder }));
    sections.push(answers.productMix.presentation);
    const built = sections.map((section) => section.id);
    if (JSON.stringify(built) !== JSON.stringify(insightsPageSectionIds))
        throw new Error(`INSIGHT_PRESENTATION_INVALID: built page sections [${built.join(', ')}] differ from the declared list [${insightsPageSectionIds.join(', ')}]`);
    return insightPagePresentationSchema.parse({ sections });
}
//# sourceMappingURL=insights-page.js.map